import React from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, className = "", delay = 0, y = 44, once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-90px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for big headings.
export function MaskedLines({ lines, className = "", lineClassName = "", start = true, stagger = 0.12, delay = 0 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pt-[0.22em] -mt-[0.22em]">
          <motion.span
            className={`block leading-[1] ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={start ? { y: "0%" } : {}}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

export function useReveal(ref) {
  return useInView(ref, { once: true, margin: "-90px" });
}
